<template>
    <section class="section text-section">
        <img class="text-section__bg" src="@/assets/images/text-section.png" alt="img"/>

        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <h2 class="text-section__heading">BU!LD BCH!</h2>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-8 offset-lg-4 col-xl-7 offset-xl-4">
                    <h3 class="text-section__title">
                        Delivering the Tools Devs Need
                        <br/>to BUIDL Their Wildest Dreams
                    </h3>

                    <p>
                        Our global community is at work 24/7, creating advanced tools, deploying new services and supporting nascent projects, that BUIDLers will use to create a new world of oppotunities, and a better future for all.
                    </p>

                    <a class="button button--primary" href="javascript://">
                        Start BUIDLing Now!</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        // msg: String
    }
}
</script>

<style scoped>
/*  */
</style>
